import CityPageTemplate from "../city-template/CityPageTemplate";
import { mckinneyConfig } from "./data";

export default function McKinneyPage() {
  return <CityPageTemplate config={mckinneyConfig} />;
}